import ReactDOM from 'react-dom';

/**
 * مودال ساده برای پاسخ‌نامه در حالت تکی + فقط جلو (مشاهده پاسخ یا پیام قفل)
 */
function ForwardOnlySheetModal({ isOpen, onClose, title, text, children }) {
    if (!isOpen) return null;
    const root = typeof document !== 'undefined' ? document.getElementById('backdrop-root') : null;
    if (!root) return null;

    return ReactDOM.createPortal(
        <>
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(0,0,0,0.45)',
                    zIndex: 10000,
                }}
                onClick={onClose}
                aria-hidden
            />
            <div
                role="dialog"
                aria-modal="true"
                style={{
                    position: 'fixed',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10001,
                    background: '#fff',
                    borderRadius: 12,
                    padding: 20,
                    maxWidth: 420,
                    width: '90%',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 style={{ margin: '0 0 12px', fontSize: 18 }}>{title}</h3>
                {text && (
                    <p style={{ margin: '0 0 12px', color: '#4b5563', lineHeight: 1.6 }}>{text}</p>
                )}
                {children}
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        marginTop: 16,
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: 8,
                        background: '#111827',
                        color: '#fff',
                        cursor: 'pointer',
                        width: '100%',
                    }}
                >
                    بستن
                </button>
            </div>
        </>,
        root
    );
}

export default ForwardOnlySheetModal;
